<!-- MenuSubList.vue -->
<template>
  <ul class="child-menu child-menu-item" :class="['level' + currentLevel, { 'columns2': currentLevel == 3 }]">
    <li
    v-for="(item, index) in menuItems" :key="index" class="child-menu-list" :class="{ 'parent': item.children }"
      @mouseover="showChildMenu(index)" @mouseleave="showChildMenu(null)">
      <a
      v-if="isExternalUrl(item.url_key)" class="child-menu-list-link" :href="item.url_key"
        target="_blank" rel="noopener noreferrer" @click="closeNav(false)">
        <span @click="navigationTracking(item)">
          {{ item.title }}
        </span>
      </a>
      <nuxt-link
      v-else-if="item.url_key" class="child-menu-list-link" :to="getMenuLink(item.url_key)"
        @click.native="closeNav(false)">
        <span @click="navigationTracking(item)">
          {{ item.title }}
        </span>
      </nuxt-link>
      <span v-else>
        {{ item.title }}
      </span>
      <MenuSubList
      v-if="item.children && item.children.length > 0 && activeItemKey == index"
          :current-level = "parseInt(item.level)" :menu-items="item.children" />
    </li>
  </ul>
</template>

<script>
import { ref, inject, useContext } from "@nuxtjs/composition-api";
import { useGtm } from "~/composables";
import { getLocalizedPath, isExternalUrl } from "~/helpers/getLocalizedPath";
export default {
  name: 'MenuSubList',
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
    isShowGrid: {
      type: Boolean,
      default: false
    },
    currentLevel: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const { app: { i18n } } = useContext();
    const { closeNav } = inject('isOpen');
    const activeItemKey = ref(null);
    const { eventCustomlinksInteracted } = useGtm();
    const showChildMenu = function (key) {
      activeItemKey.value = key;
    };

    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };
    const getMenuLink = (urlKey) => getLocalizedPath(urlKey, i18n);
    return {
      activeItemKey,
      showChildMenu,
      closeNav,
      navigationTracking,
      getMenuLink,
      isExternalUrl
    };
  }
};
</script>
<style lang="scss" scoped>
.sf-header__navigation .menu-item-container .sub-menu .sub-menu-item .child-menu {
  &.child-menu-item {
    position: absolute;
    right:  calc(0px - var(--header-menu-width));
    top: 0;
    margin-top: 0;
    width: var(--header-menu-width);
    min-height: 100%;
    height: var(--header-menu-height);

    &.columns2 {
      --bs-columns: 2;
      --bs-rows: 0;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 1.4rem 0;
      width: calc(100vw - var(--header-menu-width) * 2 - 48px - var(--menu-left-spacer));
      right: calc(0px - (100vw - var(--header-menu-width) * 2 - 48px - var(--menu-left-spacer)) );
      align-content: flex-start;
      @include for-mobile($desktop-xl-min) {
        gap: 1rem 0;
      }
      @media (max-width: $screen-1280) {
        gap: .5rem 0;
      }
      .child-menu-list {
        padding-right: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
        line-height: 23px;
        overflow: hidden;
        @media(max-width: $screen-1640) {
          max-width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.child-menu {
  list-style-type: none;
  padding: 0 0 0 16px;
  margin: 20px 0 0;
  border-left: 1px solid #d7d2cb;
  position: relative;
}

.child-menu-list {
  padding-bottom: var(--spacer-sm);

  @media (max-width: $screen-1280) {
    padding-bottom: var(--spacer-xs);
  }
  &:last-child {
    padding-bottom: 0;
  }

  &.parent {
    &:hover {
      &:after {
        content: ">";
        font-size: 1.125rem;
        color: var(--_c-cyan-primary);
        float: right;
        margin-right: 60px;
        @include for-mobile($desktop-xl-min) {
          margin-right: 30px;
        }
      }
    }

    .child-menu-list-link {
      font-family: var(--font-family--text--regular);
      font-weight: var(--font-weight--normal);
      font-size: 0.9rem;
      line-height: 0.9rem;
      color: var(--_c-black-primary);

      &:hover {
        color: var(--_c-cyan-primary);
      }
    }
  }
}
</style>
